function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Children, useRef, useState } from 'react';
import { Box, Drop, Text } from 'grommet';
import { withTheme } from 'styled-components';
import PropTypes from 'prop-types';
import _ from 'lodash';
const debounceOptions = {
  leading: true,
  trailing: false
};
const Tooltip = ({
  align,
  children,
  content,
  debounced,
  disabled,
  ...rest
}) => {
  const defaultIsVisible = false;
  const [isVisible, setIsVisible] = useState(defaultIsVisible);
  const childRef = useRef();
  const handleMouseEnter = () => !disabled && setIsVisible(true);
  const handleMouseLeave = () => setIsVisible(false);
  const debouncedHandleMouseEnter = _.debounce(handleMouseEnter, 200, debounceOptions);
  const debouncedHandleMouseLeave = _.debounce(handleMouseLeave, 200);
  const getAlignmentObj = () => {
    const alignmentObj = {};
    switch (align) {
      case 'left':
        alignmentObj.right = 'left';
        break;
      case 'right':
        alignmentObj.left = 'right';
        break;
      case 'top':
        alignmentObj.bottom = 'top';
        break;
      case 'bottom':
        alignmentObj.top = 'bottom';
        break;
      default:
        break;
    }
    return alignmentObj;
  };
  return /*#__PURE__*/React.createElement("span", {
    // style={width?width:{width: '100%'}}
    // style={{display: 'inline-block'}}
    onMouseEnter: debounced ? debouncedHandleMouseEnter : handleMouseEnter,
    onMouseLeave: debounced ? debouncedHandleMouseLeave : handleMouseLeave,
    ref: childRef,
    onFocus: handleMouseLeave,
    onBlur: handleMouseLeave
  }, Children.only(children), childRef.current && isVisible && /*#__PURE__*/React.createElement(Drop, {
    align: getAlignmentObj(),
    elevation: "small",
    target: childRef.current,
    plain: true
  }, /*#__PURE__*/React.createElement(Box, _extends({
    align: "center",
    margin: "xsmall",
    pad: "small",
    background: "dark-3",
    round: "xsmall",
    overflow: {
      vertical: 'auto',
      horizontal: 'hidden'
    }
  }, rest), /*#__PURE__*/React.createElement(Text, {
    color: "text",
    size: "small"
  }, content))));
};
Tooltip.defaultProps = {
  align: 'right',
  debounced: true,
  disabled: false
};
Tooltip.propTypes = {
  align: PropTypes.oneOf(['bottom', 'left', 'right', 'top']),
  content: PropTypes.node,
  bottom: PropTypes.bool,
  debounced: PropTypes.bool,
  disabled: PropTypes.bool
};
export default withTheme(Tooltip);